import React from 'react';
import moment from 'moment';
import { Button } from 'freemium-ui';
import { Flex } from '@rebass/grid';
import { AppConsumer } from 'shared/Application/app-context';
import Icons from 'components/Icons';
import { Trans, useTranslation } from 'react-i18next';
import ProfileDropdown from '../ProfileDropdown';
import CreateIncident from '../CreateIncident';
import Banner from '../Banner';
import { StyledTopBar, HelloBar } from './style';
import Breadcrumb from './breadcrumb';
import ChangeComponentStatus from '../ChangeComponentStatus';
import i18n from '../../i18n';
import FsMigrationBanner from '../FsMigrationBanner';
// import SelectAccount from 'components/SelectAccount';

export const getPageNameFromRoute = uri => {
  const hasText = word => uri.indexOf(word) > -1;
  return hasText('status')
    ? i18n.t('components.globalSideNav.layoutAndCustomization')
    : hasText('settings')
    ? i18n.t('components.globalSideNav.settings')
    : hasText('reports')
    ? i18n.t('components.globalSideNav.reports')
    : i18n.t('components.globalSideNav.incidentAndMaintenanceLabel');
};
export const pageUrl = account => {
  const { freshid_accounts_name, name } = account;
  const { hostname } = window.location;
  const url =
    hostname.indexOf('localhost') > -1 || hostname.indexOf('sta91ng') > -1
      ? `https://${freshid_accounts_name}.freshstatus-sta91ng.io`
      : `https://${freshid_accounts_name}.freshstatus.io`;
  return { url, name };
};

type GlobalTopNavProps = {
  location: any,
  uri: string
};

const GlobalTopNav = (props: GlobalTopNavProps) => {
  const { t } = useTranslation();
  return (
    <>
      {/* <StyledHeaderPlaceholder /> */}
      <AppConsumer>
        {({
          user,
          activationState,
          currentAccount,
          currentAccountMeta,
          components,
          getComponents,
          componentState,
          // changeAccounts,
          ...rest
        }) => {
          const helloBar = activationState && activationState !== 'AC';
          const statuspageurl = currentAccount && pageUrl(currentAccount);
          const isExploreOrSettings =
            props.location.pathname.indexOf('/explore') !== -1 ||
            props.location.pathname.indexOf('/settings') !== -1 ||
            props.location.pathname.indexOf('/incidents') !== -1;
          const isOldUser = user && moment().diff(user.created_on, 'days') >= 5;
          return (
            <StyledTopBar>
              {!isExploreOrSettings && isOldUser ? (
                <Banner banner="explore" uri={props.uri} />
              ) : null}
              {currentAccount && currentAccount.deprecation_date && <FsMigrationBanner user={user} deprecationDate={currentAccount.deprecation_date}/>}
              <div
                className={
                  helloBar
                    ? 'application-header hellobar'
                    : 'application-header'
                }
              >
                {helloBar ? (
                  <HelloBar>
                    <Trans
                      i18nKey="components.globalTopNav.helloBar"
                      values={{ email: user.email }}
                      components={{ b: <b /> }}
                    />
                  </HelloBar>
                ) : null}
                <Flex
                  justifyContent="space-between"
                  alignItems="center"
                  width="100%"
                  pb="10px"
                  pt="14px"
                  className={helloBar ? 'adjtop' : ''}
                >
                  <div className="left">
                    <Flex alignItems="center">
                      {currentAccountMeta && currentAccount ? (
                        <Breadcrumb
                          pageName={
                            currentAccountMeta &&
                            currentAccountMeta.basic_branding_data &&
                            currentAccountMeta.basic_branding_data.title
                              ? currentAccountMeta.basic_branding_data.title
                              : currentAccount.name
                          }
                        />
                      ) : null}
                    </Flex>
                  </div>
                  <div className="right">
                    {components && (
                      <ChangeComponentStatus
                        getComponents={getComponents}
                        componentState={componentState}
                        components={components}
                      />
                    )}
                    {statuspageurl && (
                      <Button
                        inline
                        size="normal"
                        type="secondary"
                        onClick={() => window.open(statuspageurl.url)}
                        style={{ height: '32px', marginRight: '12px' }}
                      >
                        <svg
                          width="11"
                          height="10"
                          viewBox="0 0 11 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M9.72857 0.0357123C9.85112 0.0871304 9.94858 0.184596 10 0.307141C10.0125 0.370649 10.0149 0.435738 10.0071 0.499998V2.93571C10.0071 3.21185 9.78329 3.43571 9.50714 3.43571C9.231 3.43571 9.00714 3.21185 9.00714 2.93571V1.71428L3.29286 7.42857C3.09514 7.62468 2.77628 7.62468 2.57857 7.42857C2.38246 7.23086 2.38246 6.912 2.57857 6.71428L8.29286 0.999998H7.06429C6.78814 0.999998 6.56429 0.776141 6.56429 0.499998C6.56429 0.223856 6.78814 -1.96326e-06 7.06429 -1.96326e-06H9.5C9.57777 -0.0026811 9.65533 0.00943855 9.72857 0.0357123ZM9 5.36428C9 5.08814 9.22386 4.86428 9.5 4.86428C9.77614 4.86428 10 5.08814 10 5.36428V8.28571C9.99609 9.23086 9.23086 9.99608 8.28572 10H1.71429C0.769138 9.99608 0.00391371 9.23086 0 8.28571V1.71428C0.00391371 0.769136 0.769138 0.00391174 1.71429 -1.96332e-06H4.63571C4.81435 -1.96596e-06 4.97941 0.0952975 5.06873 0.249998C5.15804 0.404699 5.15804 0.595297 5.06873 0.749998C4.97941 0.904699 4.81435 0.999998 4.63571 0.999998H1.71429C1.3198 0.999998 1 1.31979 1 1.71428V8.28571C1 8.6802 1.3198 9 1.71429 9H8.28572C8.6802 9 9 8.6802 9 8.28571V5.36428Z"
                            fill="#12344D"
                          />
                        </svg>
                        {t('components.globalTopNav.viewStatusPage')}
                      </Button>
                    )}
                    <CreateIncident />
                    <div className="announcement-mount" id="beamer-mount">
                      <Icons size="23" glyph="gift-box" viewBox="0 0 2 2" />
                    </div>
                    {user && currentAccount && (
                      <ProfileDropdown
                        user={user}
                        currentAccount={currentAccount}
                      />
                    )}
                  </div>
                </Flex>
              </div>
            </StyledTopBar>
          );
        }}
      </AppConsumer>
    </>
  );
};
export default GlobalTopNav;
